import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClientProfile from "@Shared/@Assets/img/add-lead.png";
import CreateApp from "@Shared/@Assets/img/create-application.png";
import CustomizePortal from "@Shared/@Assets/img/customize-portal.png";
import AddAgent from "@Shared/@Assets/img/add-agents.png";
import EditProfile from "@Shared/@Assets/img/update-profile.png";
import ImportFilogix from "@Shared/@Assets/img/import-filogix.png";
import FinishTutorial from "@Shared/@Assets/img/all-set.png";
import TutorialSlide from "@Shared/components/general/tutorial-slide.vue";
import { showToast } from "@Shared/utils/constants";
import { UPDATE_ACCOUNT_PREFERENCES } from "@Broker/@Modules/main/store/account/account-actions";
import { mapActions, mapState, mapGetters } from "vuex";
import { CURRENT_ACCOUNT_DETAILS } from "@Broker/@Modules/main/store/account/account-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "Tutorial",
  components: {
    TutorialSlide
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("AccountStore", ["accountPreferences"])), mapGetters("AccountStore", [CURRENT_ACCOUNT_DETAILS])), {}, {
    isBroker() {
      return this.CURRENT_ACCOUNT_DETAILS.accountType === "broker";
    },
    clientProfileImg() {
      return ClientProfile;
    },
    createAppImg() {
      return CreateApp;
    },
    portalImg() {
      return CustomizePortal;
    },
    addAgentImg() {
      return AddAgent;
    },
    editProfileImg() {
      return EditProfile;
    },
    filogixImg() {
      return ImportFilogix;
    },
    finishImg() {
      return FinishTutorial;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("AccountStore", [UPDATE_ACCOUNT_PREFERENCES])), {}, {
    async disableTutorial() {
      const data = _objectSpread(_objectSpread({}, this.accountPreferences), {}, {
        tutorial: false
      });
      await this.UPDATE_ACCOUNT_PREFERENCES(data);
      showToast("info", "tutorialHidden");
    }
  })
});